import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactService } from '../contact-form/contact.service';

@Component({
  selector: 'app-demo-contact-form',
  templateUrl: './demo-contact-form.component.html',
  styleUrls: ['./demo-contact-form.component.css']
})
export class DemoContactFormComponent implements OnInit {
  @Output() formSubmitted = new EventEmitter<boolean>();
  
  demoForm: FormGroup;
  submitted: Boolean = false;
  response_message: any;
  rep_color_code: string;
  isLoading = false;

  constructor(private formBuilder: FormBuilder, private contactService: ContactService) { }

  ngOnInit() {
    this.init();
  }

  get f() {
    return this.demoForm.controls;
  }

  init() {
    this.demoForm = this.formBuilder.group({
      firstname: ['', [Validators.maxLength(200), Validators.minLength(3), Validators.required]],
      lastname: ['', [Validators.maxLength(200), Validators.minLength(3), Validators.required]],
      emailid: ['', [Validators.email, Validators.required]],
      mobilenumber: ['', [Validators.required, Validators.minLength(10),
      Validators.maxLength(12), Validators.pattern('^(0|[1-9][0-9]*)$')]],
      queryType: ['', [Validators.required]], // New field for query type
      comment: ['', [Validators.maxLength(300)]],
      newslettersubcription: ['']
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.demoForm.invalid) {
      return;
    }

    this.isLoading = true;
    
    // Add query type to the form data
    const formData = {
      ...this.demoForm.value,
      partner_yn: this.demoForm.value.queryType === 'partner' ? 'true' : 'false'
    };

    this.contactService.saveContactUsForm(formData).subscribe(
      (data: any) => {
        this.rep_color_code = 'green';
        this.response_message = data.message;
        this.isLoading = false;
        this.formSubmitted.emit(true);
        setTimeout(() => {
          this.resetForm();
        }, 4000);
      },
      error => {
        this.rep_color_code = 'red';
        this.response_message = error.error.comment || 'An error occurred. Please try again.';
        this.isLoading = false;
      }
    );
  }

  resetForm() {
    this.demoForm.reset();
    this.submitted = false;
    this.response_message = null;
    this.isLoading = false;
  }
}
